module.exports = __webpack_public_path__ + "img/blindNotreceive.ae1f8a4f.png";